import * as React from "react";
import { WrappedComponentProps, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { saveActiveTradingAccount } from "../Platform/State";
import { Button } from "antd";
import { TradingAccount } from "swan-public-api-client";
import { ButtonType } from "antd/lib/button";

interface PropsFromActions {
  setActiveTradingAccountAction: typeof saveActiveTradingAccount;
}

interface Props extends WrappedComponentProps, PropsFromActions {
  type?: ButtonType;
  block?: boolean;
}

class SwitchAccountButtonCmp extends React.PureComponent<Props> {
  public render() {
    return (
      <Button
        type={this.props.type}
        block={this.props.block}
        icon="swap"
        onClick={() => this.onClick()}
      >
        {this.props.intl.formatMessage({ id: "switchAccountButton.text" })}
      </Button>
    );
  }

  private onClick() {
    this.props.setActiveTradingAccountAction(undefined);
  }
}

const SwitchAccountButtonWithIntl = injectIntl(SwitchAccountButtonCmp);

const mapDispatchToProps = (dispatch: any): PropsFromActions => ({
  setActiveTradingAccountAction: (tradingAccount: TradingAccount | undefined) => dispatch(saveActiveTradingAccount(tradingAccount))
});

export const SwitchAccountButton = connect(
  null,
  mapDispatchToProps
)(
  SwitchAccountButtonWithIntl
);
